/**
 * Supabase client configuration for browser-side authentication
 */
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Please add VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to your .env file.'
  );
}

// Clean up our custom storage key from previous deploys
if (localStorage.getItem('recon-auth-session')) {
  localStorage.removeItem('recon-auth-session');
}

// autoRefreshToken is disabled because we handle ALL token refresh through the backend
// (/auth/refresh endpoint) which re-validates Tekion and updates tekion_verified_at.
// Supabase's native refresh would race with our backend refresh when both fire on the
// same refresh token simultaneously, causing "Invalid Refresh Token: Already Used" errors.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: false,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
  },
});
